import { AddOutlined } from '@mui/icons-material'
import { Fab } from '@mui/material'
import { DataGrid, GridColDef, GridValidRowModel } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import {
    availablePageSizes,
    searchParamsPaginationDefaultValues,
} from '@/schemas/searchParams/searchParamsPaginationSchema'
import { CustomAdminDataGridToolbar } from './CustomAdminDataGridToolbar'

/**
 * Is used for the pending state of the overview admin pages.
 * Displayes a `DataGrid` with the passed `columns`, in the loading state.
 */
export const AdminOverviewPagePendingComponent = <T extends GridValidRowModel>({
    pageTitle,

    columns,
    page = searchParamsPaginationDefaultValues.page,
    pageSize = searchParamsPaginationDefaultValues.pageSize,
    searchText = '',
}: {
    pageTitle: string

    columns: GridColDef<T>[]
    page?: number
    pageSize?: number
    searchText?: string
}): React.ReactNode => {
    const { t } = useTranslation()

    return (
        <div>
            <title>{pageTitle}</title>

            <DataGrid
                loading={true}
                columns={columns}
                pageSizeOptions={availablePageSizes}
                disableRowSelectionOnClick={true}
                slots={{ toolbar: CustomAdminDataGridToolbar }}
                slotProps={{
                    toolbar: {
                        disabled: true,
                        createButton: (
                            <Fab
                                variant={'extended'}
                                color={'primary'}
                                disabled={true}
                            >
                                <AddOutlined /> {t('common.new')}
                            </Fab>
                        ),
                        initialSearchText: searchText,
                    },
                }}
                paginationModel={{ page, pageSize }}
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnResize={true}
                disableColumnSelector={true}
                disableColumnSorting={true}
                disableDensitySelector={true}
                disableMultipleRowSelection={true}
                showToolbar={true}
            />
        </div>
    )
}
